import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import ArrowLeft from '../Images/ArrowLeft';
import BrandLogoIcon from '../Images/BrandLogoIcon';

const MainContainer = styled.div`
  flex-grow: 1;
  min-height: 100vh;
  /* background-color: ${({ theme }) => theme.colors.surface.sf300}; */
  background-color: white;
  width: calc(100% - 240px);
  transition: width 0.2s;

  @media (max-width: 960px) {
    width: 100%;
  }
`;
const NavBar = styled.div`
  display: none;
  @media (max-width: 960px) {
    display: flex;
    align-items: center;
    padding: 12px;
    gap: 12px;
    width: 100vw;
  }
`;

function PublicPageBackButtonNavbar({ children }) {
  const navigate = useNavigate();
  const location = useLocation();

  const handleBack = () => {
    if (window.Android) {
      if (window.Android.closePage) {
        console.log('Executed closePage');
        window.Android.closePage();
      }
    }
    if (location.key) navigate(-1);
    else navigate('/');
  };

  return (
    <MainContainer>
      <NavBar>
        <ArrowLeft onClick={() => handleBack()} />
        <BrandLogoIcon />
      </NavBar>
      {children}
    </MainContainer>
  );
}

export default PublicPageBackButtonNavbar;
